import { DOUDIAN_SE_APP_KEY } from "@/config";

const sensUrls = [
    "/order/list_decrypted_consignee",
    "/order/list_decrypted_consignee_for_print",
    "/order_export/download",
    "/order_export_task/create",
    "/ewaybill/generate",
    "/order_export/submit_task",
];

/**
 * 抖店安全审计
 */
export function ByteSecurityOpenInit(accountId: number) {
    if (window.BYTES_OPEN_int) {
        console.log("接入抖店安全审计...");

        window.BYTES_OPEN_int({ accountId: String(accountId), appKey: DOUDIAN_SE_APP_KEY, sensUrls });
    }
}
